import React from "react";
import { getCognitoAiList } from "../../services/CognitoAi";
import Constants from "../../services/Constants";
import OTAPagination from "../OTAPagination";
import { getCognitoAiDataColumns } from "./CognitoAiDataColumns";

const CognitoAiDataGrid = (props) => {
  const columns = getCognitoAiDataColumns();

  return (
    <OTAPagination
      columns={columns}
      endpoint={Constants.LIST_COGNITO_AI}
      endpointFn={getCognitoAiList}
      queryName={"cognitoAiUploads"}
      filterMode="server"
      getRowId={(row) => row.uploadId}
      exportCSV
      {...props}
    />
  );
};

export default CognitoAiDataGrid;
